<!--
 * @Descripttion: 编辑项目
 * @Date: 2025-04-23 14:02:27
-->
<template>
  <div class="project-center-edit-list__name">
    <div
      v-if="showIndex"
      style="flex-shrink: 0; display: flex; align-items: center"
    >
      <p class="project-center-edit-list__index">
        <BaseSvg
          iconClass="shouye"
          style="font-size: 19px; margin-right: 10px"
        ></BaseSvg>
        <span @click="onGoBack">项目中心</span>
      </p>
      <p class="project-center-edit-list__line"></p>
    </div>

    <div
      v-if="sceneName && sceneName !== '-'"
      style="flex-shrink: 0; display: flex; align-items: center"
    >
      <p class="project-center-edit-list__scene">
        {{ sceneName }}
      </p>
      <p class="project-center-edit-list__arrow"></p>
    </div>

    <div style="display: flex; align-items: center; flex: 1">
      <div>
        <BaseToolTip
          style="
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            line-clamp: 1;
            white-space: initial;
            word-break: break-all;
          "
          over-show
          :content="projectName"
        >
          <span>{{ projectName }}</span>
        </BaseToolTip>
      </div>

      <div v-if="projectCode" style="flex-shrink: 0">
        （项目编码：
        <span class="projectCode" @click="useCopy(projectCode)">
          {{ projectCode }}
          <BaseIcon><CopyDocument /></BaseIcon>
        </span>

        ）
      </div>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import { CopyDocument } from '@element-plus/icons-vue';
import { useRouter } from 'vue-router';
import { BaseToolTip, BaseIcon } from 'xrk-components';

import { BaseSvg } from '@/components/base/base-svg/index';
import { useCopy } from '@/hooks/use-copy';

withDefaults(
  defineProps<{
    sceneName: string;
    projectName: string;
    projectCode: string;
    showIndex: boolean;
  }>(),
  {
    showIndex: true
  }
);

const router = useRouter();

const onGoBack = async () => {
  window.sessionStorage.removeItem('projectDetail');
  router.push({
    name: 'project-center-list'
  });
};
</script>

<style lang="scss" scoped>
.project-center-edit-list__name {
  flex: 1;
  display: flex;
  align-items: center;
  font-size: 12px;

  .projectCode {
    color: var(--xrk-color-primary2);
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
    &:active {
      opacity: 1;
    }
  }

  .project-center-edit-list__index {
    color: #636363;
    display: flex;

    > span {
      color: var(--xrk-color-primary);

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
      &:active {
        opacity: 0.8;
      }
    }
  }
  .project-center-edit-list__line {
    width: 1px;
    height: 10px;
    background: #636363;
    margin: 0 8px;
  }
  .project-center-edit-list__scene {
    color: #909090;
  }
  .project-center-edit-list__arrow {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-right: 1px solid #636363;
    border-top: 1px solid #636363;
    transform: rotate(45deg);
    margin: 0 10px 0 5px;
  }
}
</style>
